import { useState } from "react";
import api from "../lib/api";
import { useSettings } from "../context/SettingsContext";
import { toast } from "sonner";
import { Mail, Phone, MapPin, Send, MessageCircle } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const { settings } = useSettings();
  const c = settings?.contact || {};
  const m = settings?.messaging || {};
  const waLink = m.whatsapp ? `https://wa.me/${m.whatsapp.replace(/[^0-9]/g, "")}` : "";
  const tgLink = m.telegram ? `https://t.me/${m.telegram.replace(/^@/, "")}` : "";

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setSent(true); toast.success("Messaggio inviato!"); setForm({ name: "", email: "", phone: "", message: "" }); }
    catch { toast.error("Errore, riprova."); }
  };

  const items = [
    { icon: Mail, t: "Email", s: c.email, href: c.email ? `mailto:${c.email}` : "" },
    { icon: Phone, t: "Telefono", s: c.phone, href: c.phone ? `tel:${c.phone}` : "" },
    { icon: MapPin, t: "Studio", s: c.address, href: "" },
  ].filter((i) => i.s);

  return (
    <div>
      <section className="bg-navy py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-white">Contatti</h1>
          <p className="text-slate-300 mt-4 max-w-2xl mx-auto text-lg">Hai bisogno di una consulenza professionale diretta? Scrivimi.</p>
        </div>
      </section>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-[1fr_1.4fr] gap-12">
        <div className="space-y-6">
          {items.map((x) => (
            <div key={x.t} className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-xl bg-navy flex items-center justify-center shrink-0"><x.icon className="w-5 h-5 text-gold" /></span>
              <div>
                <div className="font-semibold text-navy">{x.t}</div>
                {x.href ? <a href={x.href} className="text-slate-500 hover:text-navy">{x.s}</a> : <div className="text-slate-500">{x.s}</div>}
              </div>
            </div>
          ))}

          {(waLink || tgLink) && (
            <div className="pt-4 border-t border-slate-100">
              <div className="text-sm font-semibold text-navy mb-3">Scrivimi su</div>
              <div className="flex gap-3">
                {waLink && (
                  <a href={waLink} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="flex items-center gap-2 bg-emerald text-white rounded-full px-5 py-2.5 text-sm font-medium hover:opacity-90 transition-opacity">
                    <MessageCircle className="w-4 h-4" /> WhatsApp
                  </a>
                )}
                {tgLink && (
                  <a href={tgLink} target="_blank" rel="noopener noreferrer" data-testid="contact-telegram" className="flex items-center gap-2 bg-navy text-white rounded-full px-5 py-2.5 text-sm font-medium hover:bg-petrol transition-colors">
                    <Send className="w-4 h-4" /> Telegram
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
        <form onSubmit={submit} className="bg-white border border-slate-100 rounded-2xl p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome e cognome" data-testid="contact-name" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:border-navy" />
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="contact-email" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:border-navy" />
          </div>
          <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Telefono (opzionale)" data-testid="contact-phone" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:border-navy" />
          <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Il tuo messaggio" data-testid="contact-message" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:border-navy resize-none" />
          <button type="submit" data-testid="contact-submit" className="flex items-center justify-center gap-2 w-full bg-navy text-white rounded-full py-3.5 font-medium hover:bg-petrol transition-all">
            <Send className="w-4 h-4" /> {sent ? "Inviato ✓" : "Invia messaggio"}
          </button>
        </form>
      </div>
    </div>
  );
}
